export default "__VITE_ASSET__2897f91c__"